import React, { useEffect, useState, useContext } from "react";
import { Row, Col, Nav, Tab } from "react-bootstrap";
import {
  LoaderWrapper,
  BankSlide,
  AddressSlide,
  EmployeeDetailsCard,
  EmployeeSliderDetails,
} from "../../../components";
import * as fileSaver from "file-saver";
import {
  PlanCards,
  SearchableList,
  FieldDropSide,
  FieldButtonGroup,
  SliderPanel,
  FieldInput,
  UploadComponentLoans,
  LoanCard,
  BankDetails,
  AddressDetails,
  FieldInputDollarBox,
} from "../../../components";
import {
  getAdvancedPathWithParam,
  ROUTES,
  MANAGE_CENSUS_ROUTES,
  FLOW_TYPES,
  repaymentMethods,
  uploadDocumentThrough,
} from "../../../utils";
import { setManageTransactionLoanRequestData } from "../../../contexts";
import { useDeepEffect, useRequest, useRouterParams } from "../../../abstracts";
import {
  getEmployeeImage,
  getCompanyLogo,
  getCountriesList,
  getStates,
  getStatesList,
  saveInProgressLoanRequest,
  getPayrollFrequencies,
} from "../../../services";
import ManageDistributionLayout from "../../../components/ManageDistributionLayout/ManageDistributionLayout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/pro-light-svg-icons";
import { Field, Form, Formik } from "formik";
import {
  distributionFormFields,
  manageDistributionFormNames,
  MANAGE_DISTRIBUTION_ROUTES,
} from "../../../utils/constants/distribution";
import { Link, useHistory } from "react-router-dom";
import SourceSplitupContainer from "../SourceSplitupContainer";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import {
  getEmployeeEligiblePlanLoans,
  getLoanSummaryById,
} from "../../../services";
import ContentPreviewer from "../../../components/ContentPreviewer";
import {
  manageDistributionStore,
  setWithdrawalRequestPageData,
} from "../../../contexts";
import {
  loanDownloadTemplate,
  uploadLoanDocumentsRequest,
} from "../../../services/withdrawal";
import {
  CalculateLoanSourceSplit,
  getFilteredRkData,
} from "./CalcuateLoanSourceSplit";
import payrollFrequency from "./../../../mocks/payrollFrequency.json";
import { getCurrentDateInDDMMYYYY } from "../../../utils";
import { MANAGE_TRANSACTION_ROUTES } from "./../../../utils/constants/transaction";
import {
  CalculateAmortizationSchedule,
  getPathWithParam,
  getPeriodicPayment,
} from "./../../../utils/helpers";
import { get, isEmpty, isEqual } from "lodash";
import { faAngleDown, faDownload } from "@fortawesome/pro-solid-svg-icons";
import AmortizationSchedule from "../LoanSummaryContainer/AmortizationSchedule/AmortizationSchedule";

const formName = manageDistributionFormNames.LOAN_REQUEST;
const fields = distributionFormFields[formName];
const accountTypeOptions = [
  {
    label: "Saving Account",

    value: 1,
  },

  {
    label: "Checking Account",

    value: 2,
  },
];
const paymentOptions = [
  {
    label: "EFT",
    value: 2,
  },
  {
    label: "Mail Check to Address",
    value: 1,
  },
];

export const calculateAvailableBalanceForLoan = (planData) => {
  const {
    highestOutstandingLoanBalance = 0,
    outstandingLoanBalance = 0,
  } = planData;
  const calculateMaximumLoanAmount = (limit) => {
    return limit - highestOutstandingLoanBalance ?? 0;
  };
  let vestedBalanceForSelectedPlan = planData?.sourceBalances?.reduce(
    (a, v) =>
      (a = a + v?.vestingMultiplier * v?.sourceEmployeeMap?.accountBalance),
    0
  );

  const limit = 50000;

  const maximumLoanAmount =
    Math.min(
      vestedBalanceForSelectedPlan * 0.5,
      calculateMaximumLoanAmount(limit)
    ) - (outstandingLoanBalance ?? 0);

  let accountBalanceExcludingRestrictedInvestments = getFilteredRkData(
    get(planData, `sourceBalances`, []),
    loanSetting
  ).reduce((x, y) => x + y?.accountBalance, 0);

  const availableBalanceForLoan = Math.min(
    maximumLoanAmount <= 0 ? 0 : maximumLoanAmount,
    accountBalanceExcludingRestrictedInvestments
  );

  return availableBalanceForLoan;
};

const DownloadTemplate = (fileType) => {
  loanDownloadTemplate(fileType)
    .then((response) => {
      var blob = new Blob([response], {
        type:
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });
      if (fileType == 1) {
        fileSaver.saveAs(blob, `spousalconsent.docx`);
      } else {
        fileSaver.saveAs(blob, `promissorynote.docx`);
      }
    })
    .catch((error) => {});
};

var employeeEligiblePlans = [];
var loanTypeOptions = [];
var loanSetting = {};

const LoanRequestContainer = (props) => {
  const prime = 6;
  const limit = 50000;
  const { flow, censusId, loanRequestId, fromPage } = useRouterParams();
  const { state, dispatch } = useContext(manageDistributionStore);
  const [stateList, setStateList] = useState([]);
  const [countries, setCountries] = useState([]);
  const [employeeImage, setEmployeeImage] = useState("");
  const [tenurePeriod, setTenurePeriod] = useState(0);
  const [sliderOpen1, setSliderOpen1] = useState(false);
  const [bankSlideOpen, setBankSlideOpen] = useState(false);
  const [splitupOpen, setSplitupOpen] = useState(false);
  const [sliderOpen4, setSliderOpen4] = useState(false);
  const [addressSlideOpen, setAddressSlideOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [requestLoading, setRequestLoading] = useState(false);

  const [formValues, setFormValues] = useState({});
  const [additionalBankInformation, setAdditionalBankInformation] = useState(
    []
  );
  const [repaymentBankInformation, setRepaymentBankInformation] = useState([]);
  const [isRepaymentBankInfo, setIsRepaymentBankInfo] = useState(null);
  const [isUploadSuccess, setIsUploadSuccess] = useState(true);
  const [additionalAddress, setAdditionalAddress] = useState([]);
  const [sourceSplit, setSourceSplit] = useState([]);
  const [overnightDelivery, setOvernightDelivery] = useState(false);
  const [existingLoanData, setExistingLoanData] = useState({});
  const [moreInfoSlideOpen, setMoreInfoSlideOpen] = useState(false);
  const [documentTypeDetails, setDocumentTypeDetails] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState(0);
  const [bankInformationDetails, setBankInformationDetails] = useState([]);
  const [addressAdded, setAddressAdded] = useState(false);
  const [address, setAddress] = useState([]);
  const [frequencyList, setFrequencyList] = useState([]);
  const [existingLoanPlan, setExistingLoanPlan] = useState();
  const filteredValues = get(state, "api.censusInformation", {});
  const [expand, setExpand] = useState(false);
  const [loanDoc, setLoanDoc] = useState([]);
  const onExpand = () => {
    setExpand(!expand);
  };

  // let vestedBalanceForSelectedPlan = get(
  //   employeeEligiblePlans,
  //   `${selectedPlan}`,
  //   {}
  // )?.sourceBalances?.reduce(
  //   (a, v) =>
  //     (a = a + v?.vestingMultiplier * v?.sourceEmployeeMap?.accountBalance),
  //   0
  // );

  // const { highestOutstandingLoanBalance, outstandingLoanBalance } = get(
  //   employeeEligiblePlans,
  //   `${selectedPlan}`,
  //   {}
  // );

  // let accountBalanceExcludingRestrictedInvestments = getFilteredRkData(
  //   get(employeeEligiblePlans, `${selectedPlan}.sourceBalances`, []),
  //   loanSetting
  // ).reduce((x, y) => x + y?.accountBalance, 0);

  // const calculateMaximumLoanAmount = (limit) => {
  //   return limit - highestOutstandingLoanBalance;
  // };

  // const maximumLoanAmount =
  //   Math.min(
  //     vestedBalanceForSelectedPlan * 0.5,
  //     calculateMaximumLoanAmount(limit)
  //   ) - (outstandingLoanBalance ?? 0);
  const planData = get(employeeEligiblePlans, `${selectedPlan}`, {});
  const availableBalanceForLoan = calculateAvailableBalanceForLoan(planData);

  const frequencyListData = frequencyList;
  useDeepEffect(() => {
    if (filteredValues?.companyId) {
      getPayrollFrequencies(filteredValues?.companyId)
        .then((response) => {
          setFrequencyList(response);
        })
        .catch((error) => {
          //Handle Error
        });
    }
  }, [filteredValues?.companyId]);

  const onAddressSave = (values) => {
    let x = {
      id: 0,
      employeeId: parseInt(censusId),
      checkPayableTo: values.checkPayableTo,
      address1: values.address1,
      city: values.city,
      country: values.country,
      countryId: values.countryId,
      primaryEmailAddress: values.emailId,
      mobileNumber: values.mobileNumber,
      state: values.state,
      stateId: values.stateId,
      zipCode: values.zipCode?.toString(),
      foreignCountry: values.foreignCountry?.toString(),
      foreignState: values.foreignState?.toString(),
      foreignZipCode: values.foreignZipCode?.toString(),
    };
    setAdditionalAddress([x]);
    setAddressSlideOpen(false);
  };

  const onBankSave = (values, ind, isRepayment, setFieldValue) => {
    let x = {
      id: 0,
      employeeId: parseInt(censusId),
      nameOfTheFinancialInstitution: values.bankName,
      accountHolderName: values.accountHolderName,
      typeOfAccount: values.accountType,
      checkingSavingsAccountNumber: values.accountNumber,
      abaRoutingNumberforBankOfCreditUnion: values.creditUnion,
    };

    if (isRepayment) {
      setRepaymentBankInformation([x]);
      setFieldValue(`repaymentBankDetail`, x);
    } else {
      setAdditionalBankInformation([x]);
      setFieldValue(`bank`, x);
    }
    setBankSlideOpen(false);
  };

  useDeepEffect(
    () => {
      dispatch(
        setWithdrawalRequestPageData({
          formName: "censusId",
          fieldData: censusId,
        })
      );
    },
    [censusId],
    false
  );

  useDeepEffect(() => {
    getCountriesList().then((response) => {
      setCountries(response);
    });
  }, [countries]);

  useDeepEffect(() => {
    getStates().then((response) => {
      setStateList(response);
    });
  }, [stateList]);

  function getFileNameFromBlobPath(url) {
    return url?.split("/").pop().split("_")[0];
  }
  function getFileFromUrl(url) {
    fetch(url, { credentials: "same-origin" }).then((e) => {
      //return e.blob()
    });
  }
  // getFileFromUrl("https://storageaccountcore2ad3a.blob.core.windows.net:443/documents/core-logo_2022-08-18-01-48-29.6452457.png")

  const { response: apiData, loading: loading } = useRequest({
    method: getEmployeeEligiblePlanLoans,
    payload: censusId,
    defaultResponse: {},
  });
  var payrollSchedule = get(apiData, "payrollSchedule", []);

  employeeEligiblePlans = get(apiData, "employeePlans", []);
  const censusEmployeeClassificationIds = get(
    filteredValues,
    "employeeClassifications",
    []
  ).map((_) => _.id);
  const censusEmploymentStatusId = get(filteredValues, "employmentStatusId");

  useEffect(() => {
    if (loanRequestId && !isEmpty(apiData)) {
      setRequestLoading(true);
      getLoanSummaryById(parseInt(loanRequestId))
        .then((loanResponse) => {
          if (loanResponse.isSuccessfull) {
            const response = loanResponse.loanRequest;
            setExistingLoanData({
              ...loanResponse.loanRequest,
              spousalConsentDocURL: response?.spousalConsentDocURL
                ? [
                    {
                      blobPath: response?.spousalConsentDocURL,
                      path: getFileNameFromBlobPath(
                        response?.spousalConsentDocURL
                      ),
                    },
                  ]
                : [],

              promissoryNoteDocURL: response?.promissoryNoteDocURL
                ? [
                    {
                      blobPath: response?.promissoryNoteDocURL,
                      path: getFileNameFromBlobPath(
                        response?.promissoryNoteDocURL
                      ),
                    },
                  ]
                : [],
            });
            setAdditionalBankInformation([
              ...bankDetailsSavedEarlier(loanResponse.loanRequest),
            ]);
            setRepaymentBankInformation([
              ...repaymentbankDetailsSavedEarlier(loanResponse.loanRequest),
            ]);
            setAdditionalAddress([
              ...addressDetailsSavedEarlier(loanResponse.loanRequest),
            ]);
          }
        })
        .catch((err) => {})
        .finally(() => {
          setRequestLoading(false);
        });
    }
  }, [apiData]);
  useEffect(() => {
    if (!isEmpty(existingLoanData) && !isEmpty(apiData)) {
      const tempSelectedPlan = get(apiData, "employeePlans").findIndex(
        (x) => x.id == existingLoanData.planId
      );
      setSelectedPlan(tempSelectedPlan);
      loanSetting = get(
        apiData?.employeePlans,
        `${tempSelectedPlan}.loanSettings`,
        []
      ).find((item, index) => item.id == existingLoanData?.loanSettingId);
      setExistingLoanPlan(
        get(apiData, "employeePlans").filter(
          (x) => x.id == existingLoanData.planId
        )
      );
    }
  }, [existingLoanData, apiData]);
  useDeepEffect(() => {
    if (!isEmpty(apiData)) {
      loanTypeOptions = get(
        employeeEligiblePlans,
        `${selectedPlan}.loanSettings`,
        []
      )
        // .filter((loanSetting, ind) => {
        //   const includesEmployeeClassificationArray = censusEmployeeClassificationIds.map(
        //     (z) =>
        //       loanSetting?.excludedEmployeeClassifications
        //         .map((_) => _?.employeeClassificationId)
        //         .includes(z)
        //   );
        //   const includesEmployeeClassification = includesEmployeeClassificationArray.reduce(
        //     (previousValue, currentValue) => previousValue || currentValue,
        //     false
        //   );
        //   const includesEmploymentStatus = loanSetting?.excludedEmploymentStatuses
        //     .map((_) => _?.employmentStatusId)
        //     .includes(censusEmploymentStatusId);
        //   return !includesEmployeeClassification && !includesEmploymentStatus;
        // })
        .map((item, index) => ({
          label: item.masterLoanType.description,
          value: item.masterLoanType.id,
        }));
    }
  }, [apiData, selectedPlan]);

  const [selectedBank, setSelectedBank] = useState(
    additionalBankInformation?.findIndex((x) => get(x, "id", 0) != 0)
  );

  const history = useHistory();
  const onFormSubmit = (saveAsDraft, values, { setFieldError, setTouched }) => {
    var tempLoanDocument = [];
    var apiDocument = existingLoanData?.loanDocument;

    loanSetting?.loanDocumentType?.map((_) => {
      var docName = "document" + _.id;
      var docData = get(values, `${docName}[0]`, null);
      var docId =
        apiDocument != undefined
          ? apiDocument.find((x) => x.loanDocumentTypeId == _.id)?.id
          : 0;

      if (Object.keys(values).includes(docName) && !isEmpty(values[docName])) {
        let temp = {
          id: docId ?? 0,
          loanDocumentTypeId: docData?.loanDocumentTypeId ?? _.id,
          //name: docName,
          name: docData?.path.substr(0, docData?.path.lastIndexOf(".")),
          url: docData?.url ?? null,
          extension: docData?.path.substr(docData?.path.lastIndexOf(".") + 1),
          size: docData?.size,
        };
        tempLoanDocument.push(temp);
      }
      return tempLoanDocument;
    });

    let repaymentFreq =
      get(values, "repaymentFrequency") != null
        ? payrollFrequency.data.find(
            (_) => _.label.replace("-", "") == get(values, "repaymentFrequency")
          )?.value
        : null;
    const loanRequestValues = {
      loanDocument: tempLoanDocument,
      employeeId: censusId,
      id: loanRequestId ? existingLoanData.id : 0,
      signedThroughDocusign: get(values, "signedThroughDocusign", false),
      // employeeId: 1,
      planId: get(values, "planID"),
      loanSettingId: get(values, fields.loanType)
        ? get(loanSetting, "id")
        : null,
      loanType: get(values, fields.loanTypeDescription, null),
      loanFeeType: get(values, ""),
      loanIdentifier: get(values, "loanIdentifier"),
      reasonForLoan: get(values, "loanReason"),
      interestRate: get(values, "interestRate"),
      isDraft: saveAsDraft,
      requestedAmount: get(values, "requestedAmount"),
      periodicPaymentAmount: get(values, "periodicPayment"),
      tenureYears: get(values, "tenureYears"),
      tenureMonths: get(values, "tenureMonths"),
      paymentMethod: get(values, "paymentOption"),
      repaymentMethod: get(values, "repaymentMethod"),
      firstRepaymentDate: get(values, "firstRepaymentDate"),
      repaymentFrequency: repaymentFreq,
      repaymentBankDetail: [1, 3].includes(get(values, "repaymentMethod"))
        ? {
            nameOfFinancialInstitution: get(
              values,
              `repaymentBankDetail.nameOfTheFinancialInstitution`,
              ""
            ),
            routingNumber: get(
              values,
              `repaymentBankDetail.abaRoutingNumberforBankOfCreditUnion`
            ),
            typeOfAccount: get(values, `repaymentBankDetail.typeOfAccount`),
            accountNumber: get(
              values,
              `repaymentBankDetail.checkingSavingsAccountNumber`
            ),
            accountHolderName: get(
              values,
              `repaymentBankDetail.accountHolderName`
            ),
          }
        : null,
      eft:
        get(values, "paymentOption") === 2
          ? {
              nameOfFinancialInstitution: get(
                values,
                `bank.nameOfTheFinancialInstitution`,
                ""
              ),
              routingNumber: get(
                values,
                `bank.abaRoutingNumberforBankOfCreditUnion`
              ),
              typeOfAccount: get(values, `bank.typeOfAccount`),
              accountNumber: get(values, `bank.checkingSavingsAccountNumber`),
              accountHolderName: get(values, `bank.accountHolderName`),
            }
          : null,

      cheque:
        get(values, "paymentOption") === 1
          ? {
              checkPayableTo: get(values, `address.checkPayableTo`),
              sendPaymentTo: null,
              address: {
                address1: get(values, `address.address1`),
                address2: get(values, `address.address2`),
                address3: get(values, `address.address3`),
                // country: get(values, `address.country`),
                // state: get(values, `address.state`),
                city: get(values, `address.city`),
                zipCode: get(values, `address.zipCode`),
                countryId: get(values, `address.countryId`),
                stateId: get(values, `address.stateId`),
                foreignCountry: get(values, `address.foreignCountry`),
                foreignState: get(values, `address.foreignState`),
                foreignZipCode: get(values, `address.foreignZipCode`),
              },
            }
          : null,

      overnightDelivery: overnightDelivery,
      employeeAuthorization: get(values, ""),
      loanActivationDate: get(values, ""),
      loanRequestDate: getCurrentDateInDDMMYYYY(0),
      loanStatus: get(values, "loanStatus", 1),
      chequeFees:
        get(values, "paymentOption") === 1
          ? get(values, [fields.chequeFees])
          : 0,
      eftFees:
        get(values, "paymentOption") === 2 ? get(values, [fields.eftFees]) : 0,
      loanFeeAmount: get(values, [fields.loanFeeAmount]),
    };

    //main loan save
    setRequestLoading(true);
    setAddress(apiData["address"][0]);
    setBankInformationDetails(apiData["bankInformationDetails"][0]);
    saveInProgressLoanRequest(loanRequestValues)
      .then((response) => {
        if (response.isSuccessfull) {
          dispatch(
            setManageTransactionLoanRequestData({
              ...values,
              loanId: response["loan"]["id"],
              loanIdentifier:
                response["loan"]["loanIdentifier"] ??
                existingLoanData?.loanIdentifier,
              loanType: get(values, fields.loanTypeDescription, null),
              repaymentFrequency: repaymentFreq,
              loanSettingInfo: loanSetting,
              address: apiData["address"][0],
              loanDocument: tempLoanDocument,
              outstandingBalance: get(values, "requestedAmount"),
              bankInformationDetails: apiData["bankInformationDetails"][0],
            })
          );
          dispatch(
            setWithdrawalRequestPageData({
              formName: "sourceSplit",
              fieldData: CalculateLoanSourceSplit(
                employeeEligiblePlans[selectedPlan]?.sourceBalances,
                values,
                loanSetting,
                overnightDelivery
              ),
            })
          );
          var formData = new FormData();
          var hasloandocs = false;
          loanSetting.loanDocumentType.map((_) => {
            if (get(values, "document" + _.id + ".0.lastModified")) {
              formData.append("document" + _.id, values["document" + _.id][0]);
              hasloandocs = true;
            }
          });

          formData.append("loanRequestId", response["loan"]["id"]);

          if (hasloandocs) {
            uploadLoanDocumentsRequest(formData)
              .then((response) => {
                if (response.isSuccessfull) {
                }
              })
              .catch((error) => {
                setRequestLoading(false);
              });
          }
          fromPage == 1
            ? history.push(
                getAdvancedPathWithParam({
                  path: `${MANAGE_TRANSACTION_ROUTES.PENDINGLOANAPPROVAL}`,
                  pathParam: [flow, censusId, loanRequestId, fromPage],
                })
              )
            : saveAsDraft
            ? history.push(
                getPathWithParam({
                  path: MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_TRANSACTIONS,
                  pathParam: [flow, censusId],
                })
              )
            : history.push(
                getAdvancedPathWithParam({
                  path: `${ROUTES.LOAN_SUMMARY}`,
                  pathParam: [flow, censusId],
                })
              );
        } else {
          setRequestLoading(false);
          for (var i = 0; i < response.errorMessages.length; i++) {
            var _ = response.errorMessages[i];
            console.log("_", _);
            // setTouched(_.controlName, true);
            setFieldError(_.controlName, `${_.errorCode} : ${_.message}`);
          }
        }
      })
      .catch((error) => {
        setRequestLoading(false);
      });
  };

  const loanSettingFromApi = !isEmpty(loanRequestId)
    ? get(employeeEligiblePlans[selectedPlan], `loanSettings`, []).find(
        (_) => _.id == existingLoanData?.loanSettingId
      )
    : null;

  useEffect(() => {
    if (!isEmpty(loanRequestId) && loanSettingFromApi != undefined) {
      setDocumentTypeDetails(
        loanSettingFromApi?.loanDocumentType.map((_) => {
          return { docFieldName: "document" + _.id, hide: true };
        })
      );
      setLoanDoc(
        loanSettingFromApi?.loanDocumentType.map((_) => {
          if (_.description == "Spousal consent" && MaritalStatus == "S") {
            return (_ = { ..._, isRequired: false });
          }
          return _;
        })
      );
    }
  }, [loanSettingFromApi]);

  const initialLoanType = loanSettingFromApi?.masterLoanType.id;

  const defaultBankInfo = get(apiData, "bankInformationDetails", []);

  const bankDetailsSavedEarlier = (value) => {
    if (isEmpty(value) || value?.paymentMethod !== 2) return [];
    if (
      get(value, `eft.accountNumber`) ==
      get(defaultBankInfo, `0.checkingSavingsAccountNumber`)
    )
      return [];
    else
      return [
        {
          abaRoutingNumberforBankOfCreditUnion: value?.eft?.routingNumber,
          accountHolderName: get(value, "eft.accountHolderName", ""),
          checkingSavingsAccountNumber: value?.eft?.accountNumber,
          employeeId: value?.eft?.employeeId,
          nameOfTheFinancialInstitution: value?.eft?.nameOfFinancialInstitution,
          typeOfAccount: value?.eft?.typeOfAccount,
        },
      ];
  };

  const repaymentbankDetailsSavedEarlier = (value) => {
    if (isEmpty(value) || value?.repaymentMethod == 2) return [];
    if (
      get(value, `repaymentBankDetail.accountNumber`) ==
      get(defaultBankInfo, `0.checkingSavingsAccountNumber`)
    )
      return [];
    else
      return [
        {
          abaRoutingNumberforBankOfCreditUnion:
            value?.repaymentBankDetail?.routingNumber,
          accountHolderName: get(
            value,
            "repaymentBankDetail.accountHolderName",
            ""
          ),
          checkingSavingsAccountNumber:
            value?.repaymentBankDetail?.accountNumber,
          employeeId: value?.repaymentBankDetail?.employeeId,
          nameOfTheFinancialInstitution:
            value?.repaymentBankDetail?.nameOfFinancialInstitution,
          typeOfAccount: value?.repaymentBankDetail?.typeOfAccount,
        },
      ];
  };

  const addressDetailsSavedEarlier = (value) => {
    if (isEmpty(value) || value?.paymentMethod !== 1) return [];

    return [
      {
        checkPayableTo: get(value, "cheque.checkPayableTo", ""),
        address1: get(value, "cheque.address.address1", ""),
        address2: get(value, "cheque.address.address2", ""),
        address3: get(value, "cheque.address.address3", ""),
        country: get(value, "cheque.address.country", ""),
        state: get(value, "cheque.address.state", ""),
        city: get(value, "cheque.address.city", ""),
        zipCode: get(value, "cheque.address.zipCode", ""),
      },
    ];
  };
  const bankCardsToDisplay = () => {
    const loanSettingDetails = get(apiData, "bankInformationDetails", []);
    if (
      get(additionalBankInformation, `0.checkingSavingsAccountNumber`) ===
      get(loanSettingDetails, `0.checkingSavingsAccountNumber`)
    )
      return additionalBankInformation;
    return [...loanSettingDetails, ...additionalBankInformation];
  };

  const repaymentbankCardsToDisplay = () => {
    const loanSettingDetails = get(apiData, "bankInformationDetails", []);
    if (
      get(repaymentBankInformation, `0.checkingSavingsAccountNumber`) ===
      get(loanSettingDetails, `0.checkingSavingsAccountNumber`)
    )
      return repaymentBankInformation;
    return [...loanSettingDetails, ...repaymentBankInformation];
  };

  const addressCardsToDisplay = () => {
    const loanSettignDetails = get(apiData, "address.0", {});
    const jsonObjectAddress = (val) => {
      return {
        checkPayableTo: val?.checkPayableTo,
        address1: val?.address1,
        address2: val?.address2,
        address3: val?.address3,
        country: val?.country,
        state: val?.state,
        city: val?.city,
        zipCode: val?.zipCode,
        countryId: val?.countryId,
        stateId: val?.stateId,
        foreignCountry: val?.foreignCountry,
        foreignState: val?.foreignState,
        foreignZipCode: val?.foreignZipCode,
      };
    };
    if (
      isEqual(
        jsonObjectAddress(loanSettignDetails),
        jsonObjectAddress(get(additionalAddress, "0", {}))
      )
    )
      return additionalAddress;
    return [loanSettignDetails, ...additionalAddress];
  };

  var empFreqId = get(state, "api.censusInformation.payrollFrequencyId");
  var [bankDetails] = bankDetailsSavedEarlier(existingLoanData);
  var [repaymentDetails] = repaymentbankDetailsSavedEarlier(existingLoanData);
  var MaritalStatus = get(state, "api.censusInformation.maritalStatus");

  const draftedLoanDocument = (document = []) => {
    let documentFromApi = {};

    document.map((_) => {
      let fieldName = "document" + _.loanDocumentTypeId;
      return (documentFromApi = {
        ...documentFromApi,
        [fieldName]: [
          {
            id: _.id,
            name: _.name,
            extension: _.extension,
            size: _.size,
            url: _.url,
            loanDocumentTypeId: _.loanDocumentTypeId,
            path: `${_.name}.${_.extension}`,
          },
        ],
      });
    });

    return documentFromApi;
  };

  return (
    <>
      <LoaderWrapper isLoading={loading || requestLoading} loaderText="">
        <Formik
          initialValues={{
            loanDocument: [],
            ...draftedLoanDocument(existingLoanData?.loanDocument),
            [fields.firstRepaymentDate]: !isEmpty(existingLoanData)
              ? existingLoanData?.firstRepaymentDate
              : null,
            [fields.repaymentMethod]: !isEmpty(existingLoanData)
              ? existingLoanData?.repaymentMethod
              : null,
            [fields.repaymentFrequency]: !isEmpty(existingLoanData)
              ? payrollFrequency.data.find(
                  (_) => _.value == get(existingLoanData, "repaymentFrequency")
                )?.label
              : null,
            [fields.loanReason]: !isEmpty(existingLoanData)
              ? existingLoanData?.reasonForLoan
              : null,
            requestedAmount: !isEmpty(existingLoanData)
              ? existingLoanData?.requestedAmount
              : null,
            periodicPayment: !isEmpty(existingLoanData)
              ? existingLoanData?.periodicPaymentAmount
              : null,
            [fields.chequeFees]: !isEmpty(existingLoanData)
              ? existingLoanData?.chequeFees
              : null,
            eftFees: !isEmpty(existingLoanData)
              ? existingLoanData?.eftFees
              : null,
            loanFeeAmount: !isEmpty(existingLoanData)
              ? existingLoanData?.loanFeeAmount
              : null,
            paymentOption: !isEmpty(existingLoanData)
              ? existingLoanData?.paymentMethod
              : null,
            planID: get(
              state,
              "planID",
              employeeEligiblePlans
                ? employeeEligiblePlans[selectedPlan]?.id
                : null
            ),
            planName: get(
              state,
              "planName",
              employeeEligiblePlans
                ? employeeEligiblePlans[selectedPlan]?.planName
                : null
            ),
            rkPlanNumber: get(
              state,
              "rkPlanNumber",
              employeeEligiblePlans
                ? employeeEligiblePlans[selectedPlan]?.rkPlanNumber
                : null
            ),
            // interestRate: get(loanSetting, "loanInterestRate"),
            [fields.loanType]: initialLoanType,
            [fields.loanTypeDescription]: existingLoanData?.loanType,
            [fields.tenureYears]: existingLoanData?.tenureYears,
            [fields.tenureMonths]: existingLoanData?.tenureMonths,
            [fields.bank]: bankDetails,
            [fields.repaymentBankDetail]: repaymentDetails,
            [fields.address]: addressDetailsSavedEarlier(existingLoanData),
            [fields.interestRate]: existingLoanData?.interestRate,
            [fields.withdrawEntire]: false,
            // [fields.repaymentFrequency]:
            //   existingLoanData?.repaymentFrequency ?? null,
            loanIdentifier: existingLoanData?.loanIdentifier ?? null,
            signedThroughDocusign: existingLoanData?.signedThroughDocusign,
            loanStatus: existingLoanData?.loanStatus ?? 1,
          }}
          onSubmit={onFormSubmit}
          enableReinitialize
          validateOnChange={false}
          // validationSchema={loanSchema}
          validateOnBlur={false}
        >
          {(formProps) => {
            const {
              handleChange,
              setFieldValue,
              handleSubmit,
              setValues,
              setTouched,
              values,
              setSubmitting,
              setFieldError,
              fieldValue,
              errors,
              ...rest
            } = formProps;
            const buttons =
              fromPage == 1
                ? [
                    {
                      label: "Save as Draft",
                      variant: "primary",
                      // type: "submit",
                      onClick: () => {
                        onFormSubmit(true, values, {
                          setFieldError,
                          setTouched,
                        });
                      },
                    },
                    {
                      label: "Cancel",
                      variant: "secondary",
                      type: "button",
                      link: getAdvancedPathWithParam({
                        path: MANAGE_TRANSACTION_ROUTES.PENDINGLOANAPPROVAL,
                        pathParam: [
                          FLOW_TYPES.EDIT,
                          censusId,
                          loanRequestId,
                          fromPage,
                        ],
                      }),
                    },
                    {
                      label: "Next",
                      variant: "primary",
                      // type: "submit",
                      onClick: () => {
                        onFormSubmit(false, values, {
                          setFieldError,
                          setTouched,
                        });
                      },
                    },
                  ]
                : fromPage == 5
                ? [
                    {
                      //link: MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_TRANSACTIONS,
                      link: getPathWithParam({
                        path: MANAGE_TRANSACTION_ROUTES.DRAFT,
                      }),
                      label: "save as draft",
                      variant: "secondary",
                      type: "button",
                      flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE],
                    },
                    {
                      //link: MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_TRANSACTIONS,
                      link: getPathWithParam({
                        path: MANAGE_TRANSACTION_ROUTES.DRAFT,
                      }),
                      label: "Cancel",
                      variant: "secondary",
                      type: "button",
                      //flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE],
                    },
                    {
                      label: "Next",
                      variant: "primary",
                      link: getPathWithParam({
                        path: `${MANAGE_DISTRIBUTION_ROUTES.LOAN_SUMMARY}`,
                        pathParam: [
                          FLOW_TYPES.EDIT,
                          censusId,
                          loanRequestId,
                          fromPage,
                        ],
                      }),
                    },
                  ]
                : [
                    {
                      label: "Save as Draft",
                      variant: "primary",
                      // type: "submit",
                      onClick: () => {
                        onFormSubmit(true, values, {
                          setFieldError,
                          setTouched,
                        });
                      },
                    },
                    {
                      //link: MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_TRANSACTIONS,
                      link: getPathWithParam({
                        path: MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_TRANSACTIONS,
                        pathParam: [FLOW_TYPES.EDIT, censusId],
                      }),
                      label: "Cancel",
                      variant: "secondary",
                      type: "button",
                    },
                    {
                      label: "Next",
                      variant: "primary",
                      //type: "submit",
                      onClick: () => {
                        onFormSubmit(false, values, {
                          setFieldError,
                          setTouched,
                        });
                      },
                    },
                  ];
            const onLoanTypeChange = (value, label) => {
              loanSetting = employeeEligiblePlans[selectedPlan][
                "loanSettings"
              ].find((item, index) => item.masterLoanTypeId == value);
              setDocumentTypeDetails(
                loanSetting.loanDocumentType.map((_) => {
                  return { docFieldName: "document" + _.id, hide: true };
                })
              );
              setLoanDoc(
                loanSetting.loanDocumentType.map((_) => {
                  if (
                    _.description == "Spousal consent" &&
                    MaritalStatus == "S"
                  ) {
                    return (_ = { ..._, isRequired: false });
                  }
                  return _;
                })
              );
              var applicablePaymentMethod = get(
                loanSetting,
                "applicablePaymentMethods",
                []
              );

              setValues({
                ...values,
                ...{
                  [fields.chequeFees]: loanSetting?.checkFee,
                  eftFees: loanSetting?.eftFees,
                  loanFeeAmount: loanSetting?.loanFeeAmount,
                  [fields.loanTypeDescription]: label,
                  [fields.interestRate]: values.interestRate
                    ? values.interestRate
                    : get(loanSetting, "loanInterestRate") == 1
                    ? prime
                    : get(loanSetting, "loanInterestRate") == 2
                    ? prime + get(loanSetting, "loanInterestRateValue")
                    : get(loanSetting, "loanInterestRateValue"),
                  [fields.loanType]: value,
                  [fields.repaymentMethod]:
                    applicablePaymentMethod.length == 1
                      ? get(applicablePaymentMethod, "0")
                      : 2, //2 is the repaymenthod value for payrollDeduction
                  [fields.repaymentFrequency]:
                    applicablePaymentMethod.length == 1 &&
                    get(applicablePaymentMethod, "0") == 1
                      ? null
                      : get(
                          frequencyListData.filter((_) => _.id == empFreqId),
                          "[0].frequencyTypeString",
                          null
                        ),
                  [fields.firstRepaymentDate]: null,
                },
              });
            };

            const applicablePaymentMethod = get(
              loanSetting,
              "applicablePaymentMethods",
              []
            );
            const repaymentMethodsOptions =
              applicablePaymentMethod.length == 2
                ? repaymentMethods
                : repaymentMethods.filter(({ value }) =>
                    get(loanSetting, "applicablePaymentMethods", [])?.includes(
                      value
                    )
                  );

            return (
              <Form onSubmit={handleSubmit}>
                <ManageDistributionLayout
                  buttons={buttons}
                  layoutHeader="Loan Request"
                  censusId={censusId}
                  values={values}
                  employeeImage={employeeImage}
                  blockNavigation={true}
                  isLoanRequest={true}
                  loanRequestId={loanRequestId ? existingLoanData.id : 0}
                  loanSettingId={loanSetting?.id}
                >
                  <div
                    className="request-Page"
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                      height: "100%",
                      paddingRight: "15px",
                      // paddingLeft: "30px",
                    }}
                  >
                    <div
                      className="request-Form"
                      style={{
                        width: "70%",
                        marginRight: "30px",
                        padding: "20px 0px 0px 10px",
                        overflowY: "auto",
                        height: "80vh",
                      }}
                    >
                      <EmployeeDetailsCard
                        setMoreInfoSlideOpen={setMoreInfoSlideOpen}
                        filteredValues={filteredValues}
                      />
                      <p
                        style={{
                          fontSize: "16px",
                          fontWeight: "500",
                          color: "#333333",
                        }}
                      >
                        Select Plan
                      </p>
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <FontAwesomeIcon
                          style={{
                            fontWeight: "300",
                            fontSize: "14px",
                            color: "#333333",
                            marginRight: "5px",
                          }}
                          icon={faExclamationCircle}
                        />
                        <p style={{ fontWeight: "400", fontSize: "12px" }}>
                          The available amount is reported as of{" "}
                          <span style={{ fontWeight: "500" }}>
                            {getCurrentDateInDDMMYYYY(-1)}
                          </span>{" "}
                          and may change due to market fluctuations.
                        </p>
                      </div>

                      <PlanCards
                        {...formProps}
                        plans={
                          loanRequestId
                            ? existingLoanPlan
                            : employeeEligiblePlans
                        }
                        fields={fields}
                        selectedPlan={selectedPlan}
                        setSelectedPlan={setSelectedPlan}
                        module="Loans"
                      />

                      <Field
                        label={"Select Loan Type"}
                        isRequired
                        size="md"
                        value={values[fields.loanType]}
                        name="loanType"
                        options={loanTypeOptions}
                        disabled={!isEmpty(loanRequestId)}
                        direction="right"
                        placeholder="Select a loan type"
                        popupContent={
                          <SearchableList
                            label="Select a loan type"
                            options={loanTypeOptions}
                            onSelect={(value, label) => {
                              onLoanTypeChange(value, label);
                            }}
                            selectedValue={values[fields.loanType]}
                          />
                        }
                        component={FieldDropSide}
                      />
                      {loanSetting && get(values, "loanType") && (
                        <>
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <FontAwesomeIcon
                              style={{
                                fontWeight: "300",
                                fontSize: "14px",
                                color: "#333333",
                                marginRight: "5px",
                                marginTop: "3px",
                              }}
                              icon={faExclamationCircle}
                            />
                            <p
                              style={{
                                fontWeight: "400",
                                fontSize: "14px",
                                color: "#333333",
                              }}
                            >
                              The Processing time for your loan is{" "}
                              {loanSetting["processingTimeForLoan"]} days.
                            </p>
                          </div>
                          <Field
                            size="smd"
                            isRequired
                            placeholder=" "
                            label={"Reason for loan"}
                            name={[fields.loanReason]}
                            type="text"
                            value={values[fields.loanReason]}
                            onChange={handleChange}
                            component={FieldInput}
                          />
                          <Link
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <FontAwesomeIcon
                              style={{
                                fontWeight: "300",
                                fontSize: "14px",
                                color: "#307BF6",
                                marginRight: "5px",
                                marginTop: "3px",
                              }}
                              icon={faExclamationCircle}
                            />
                            <p
                              onClick={() => setSliderOpen1(true)}
                              style={{
                                fontWeight: "400",
                                fontSize: "14px",
                                color: "#307BF6",
                              }}
                            >
                              Policy and procedures.
                            </p>
                          </Link>
                          <p
                            style={{
                              fontSize: "16px",
                              fontWeight: "500",
                              color: "#333333",
                              marginTop: "15px",
                            }}
                          >
                            Loan Calculator
                          </p>
                          <LoanCard
                            {...formProps}
                            fields={fields}
                            data={loanSetting}
                            planData={employeeEligiblePlans[selectedPlan]}
                            payrollSchedule={payrollSchedule}
                            empFreqId={empFreqId}
                            repaymentMethodsOptions={repaymentMethodsOptions}
                            apiData={apiData}
                            tenurePeriod={tenurePeriod}
                            setTenurePeriod={setTenurePeriod}
                            frequencyListData={frequencyListData}
                            // vestedBalance={
                            //   employeeEligiblePlans[selectedPlan]
                            //     .vestedBalance
                            // }
                            filteredValues={filteredValues}
                            availableBalanceForLoan={availableBalanceForLoan}
                            setSliderOpen4={setSliderOpen4}
                            getPeriodicPayment={getPeriodicPayment}
                          />
                          {values.periodicPayment && (
                            <>
                              <p
                                style={{
                                  fontSize: "16px",
                                  fontWeight: "500",
                                  color: "#333333",
                                  marginTop: "35px",
                                  marginBottom: "15px",
                                }}
                              >
                                Payment Method
                              </p>
                              <Field
                                isRequired
                                name={fields.paymentOption}
                                size="smd"
                                style={{ marginBottom: "25px" }}
                                options={paymentOptions}
                                selectedValue={values[fields.paymentOption]}
                                onChange={(value) => {
                                  setValues({
                                    ...values,
                                    ...{
                                      [fields.paymentOption]: value,
                                      [fields.bank]:
                                        value === 2
                                          ? get(
                                              apiData,
                                              "bankInformationDetails.0",
                                              {}
                                            )
                                          : null,
                                      [fields.address]:
                                        value === 1
                                          ? get(apiData, "address.0", {})
                                          : null,
                                    },
                                  });
                                }}
                                component={FieldButtonGroup}
                              />

                              {values.paymentOption == 2 && (
                                <BankDetails
                                  isRepayment={false}
                                  setIsRepaymentBankInfo={
                                    setIsRepaymentBankInfo
                                  }
                                  setBankSlideOpen={setBankSlideOpen}
                                  bankInformationDetails={[
                                    ...bankCardsToDisplay(),
                                  ]}
                                  setBankInformationDetails={
                                    setAdditionalBankInformation
                                  }
                                  defaultBankInformation={get(
                                    apiData,
                                    "bankInformationDetails",
                                    []
                                  )}
                                  setFieldValue={setFieldValue}
                                  module={""}
                                  index={""}
                                  isLoanRequest={true}
                                  selectedIndex={
                                    loanRequestId
                                      ? bankCardsToDisplay().length === 2
                                        ? 1
                                        : 0
                                      : 0
                                  }
                                />
                              )}
                              {values.paymentOption == 1 && (
                                <>
                                  <AddressDetails
                                    module="loans"
                                    setAddressSlideOpen={setAddressSlideOpen}
                                    address={[...addressCardsToDisplay()]}
                                    defaultaddress={get(apiData, "address", [])}
                                    setFieldValue={setFieldValue}
                                    checked={true}
                                    isLoanRequest={true}
                                    selectedAddressInitialValue={
                                      loanRequestId
                                        ? addressCardsToDisplay().length === 2
                                          ? 1
                                          : 0
                                        : 0
                                    }
                                  />
                                  &nbsp;&nbsp;&nbsp;&nbsp;
                                  <div className="d-flex-row align-items-center">
                                    <input
                                      type="checkbox"
                                      style={{
                                        height: "18px",
                                        width: "18px",
                                        marginRight: "10px",
                                      }}
                                      onClick={() =>
                                        setOvernightDelivery(!overnightDelivery)
                                      }
                                    />
                                    <p style={{ margin: "0px" }}>
                                      Overnight Delivery
                                    </p>
                                  </div>
                                  <p
                                    style={{
                                      fontWeight: "400px",
                                      fontSize: "12px",
                                      color: "#777777",
                                      margin: "0px",
                                    }}
                                  >
                                    An overnight delivery charge $
                                    {loanSetting["overnightDeliveryFees"]} will
                                    be charged
                                  </p>
                                </>
                              )}
                              <p
                                style={{
                                  fontSize: "16px",
                                  fontWeight: "500",
                                  color: "#333333",
                                  marginTop: "35px",
                                  marginBottom: "5px",
                                }}
                              >
                                Fee Deduction From
                              </p>
                              <Field
                                size="sm"
                                isRequired
                                style={{ marginBottom: "0px" }}
                                label="Loan Fee Amount"
                                name={[fields.loanFeeAmount]}
                                max={999.99}
                                min={0}
                                type="text"
                                autoComplete="off"
                                value={values[fields.loanFeeAmount]}
                                onChange={handleChange}
                                component={FieldInputDollarBox}
                              />

                              {values.paymentOption == 1 && (
                                <Field
                                  size="sm"
                                  isRequired
                                  style={{ marginBottom: "0px" }}
                                  label="Cheque Fee"
                                  name={[fields.chequeFees]}
                                  max={999.99}
                                  min={0}
                                  type="text"
                                  autoComplete="off"
                                  value={values[fields.chequeFees]}
                                  onChange={handleChange}
                                  component={FieldInputDollarBox}
                                />
                              )}
                              {values.paymentOption == 2 && (
                                <Field
                                  size="sm"
                                  isRequired
                                  style={{ marginBottom: "0px" }}
                                  label="EFT Fee"
                                  name={[fields.eftFees]}
                                  max={999.99}
                                  min={0}
                                  type="text"
                                  autoComplete="off"
                                  value={values[fields.eftFees]}
                                  onChange={handleChange}
                                  component={FieldInputDollarBox}
                                />
                              )}
                              <p
                                style={{
                                  fontSize: "16px",
                                  fontWeight: "500",
                                  color: "#333333",
                                  marginTop: "15px",
                                  marginBottom: "5px",
                                }}
                              >
                                Splitups
                              </p>
                              <Link
                                onClick={() => {
                                  setSplitupOpen(true);
                                  setSourceSplit(
                                    CalculateLoanSourceSplit(
                                      employeeEligiblePlans[selectedPlan]
                                        ?.sourceBalances,
                                      values,
                                      loanSetting,
                                      overnightDelivery
                                    )
                                  );
                                }}
                              >
                                <p
                                  style={{
                                    fontWeight: "500",
                                    fontSize: "16px",
                                    color: "#307BF6",
                                  }}
                                >
                                  View Source/Investment Split-Ups
                                </p>
                              </Link>

                              <input
                                type="radio"
                                id={uploadDocumentThrough[0]}
                                name={"radioButton"}
                                value="0"
                                checked={values.signedThroughDocusign == false}
                                onChange={(e) =>
                                  setFieldValue("signedThroughDocusign", false)
                                }
                              />
                              <label for="html">
                                Upload the signed documents
                              </label>

                              <input
                                style={{ marginLeft: "20px" }}
                                type="radio"
                                id={uploadDocumentThrough[1]}
                                name={"radioButton"}
                                value="1"
                                checked={values.signedThroughDocusign == true}
                                onChange={(e) =>
                                  setFieldValue("signedThroughDocusign", true)
                                }
                              />
                              <label for="html">
                                Sign the document through DocuSign
                              </label>

                              {(values.repaymentMethod == 1 ||
                                values.repaymentMethod == 3) && (
                                <>
                                  <p
                                    style={{
                                      fontSize: "16px",
                                      fontWeight: "500",
                                      color: "#333333",
                                      marginTop: "30px",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    Repayment Bank Details
                                  </p>
                                  <BankDetails
                                    setBankSlideOpen={setBankSlideOpen}
                                    isRepayment={true}
                                    setIsRepaymentBankInfo={
                                      setIsRepaymentBankInfo
                                    }
                                    bankInformationDetails={[
                                      ...repaymentbankCardsToDisplay(),
                                    ]}
                                    setBankInformationDetails={
                                      setRepaymentBankInformation
                                    }
                                    defaultBankInformation={get(
                                      apiData,
                                      "bankInformationDetails",
                                      []
                                    )}
                                    setFieldValue={setFieldValue}
                                    module={""}
                                    index={""}
                                    isLoanRequest={true}
                                    selectedIndex={
                                      loanRequestId
                                        ? repaymentbankCardsToDisplay()
                                            .length === 2
                                          ? 1
                                          : 0
                                        : 0
                                    }
                                  />
                                </>
                              )}
                              {!values.signedThroughDocusign && (
                                <div className="upload-documents">
                                  <p
                                    style={{
                                      fontSize: "16px",
                                      fontWeight: "500",
                                      color: "#333333",
                                      margin: "0px",
                                      padding: "0px",
                                    }}
                                  >
                                    Upload Documents
                                  </p>
                                  <>
                                    {loanDoc.map((item, index) => {
                                      return (
                                        <div>
                                          <div
                                            style={{
                                              width: "100%",
                                              display: "flex",
                                              flexDirection: "row",
                                            }}
                                          >
                                            <div
                                              style={{
                                                width: "50%",
                                                padding: "50px 0px 0px 30px",
                                                border: "0.5px solid #BDBDBD",
                                                borderRight: "none",
                                                height: "142px",
                                                marginTop: "25px",
                                                borderRadius:
                                                  "10px 0px 0px 10px",
                                              }}
                                            >
                                              <p
                                                style={{
                                                  fontWeight: "600",
                                                  fontSize: "14px",
                                                  color: "#3B3B3B",
                                                  margin: "0px",
                                                }}
                                              >
                                                {item.description}
                                                {item?.isRequired == true
                                                  ? " (required)"
                                                  : " (optional)"}
                                              </p>
                                              <div
                                                style={{
                                                  display: "flex",
                                                  flexDirection: "row",
                                                }}
                                              >
                                                <p
                                                  style={{
                                                    fontWeight: "400px",
                                                    fontSize: "12px",
                                                    color: "#777777",
                                                    margin: "0px",
                                                    marginRight: "10px",
                                                  }}
                                                >
                                                  Accepted file : jpeg, png,
                                                  jpg, pdf, doc, docx
                                                </p>
                                                <p
                                                  style={{
                                                    fontWeight: "400px",
                                                    fontSize: "12px",
                                                    color: "#777777",
                                                    margin: "0px",
                                                  }}
                                                >
                                                  Max File Size: 2 MB
                                                </p>
                                              </div>
                                            </div>

                                            <div style={{ width: "50%" }}>
                                              <UploadComponentLoans
                                                isUploadSuccess={
                                                  isUploadSuccess
                                                }
                                                requiredErrorMessage={get(
                                                  errors,
                                                  "loanDocument" + item.id
                                                )}
                                                setFieldValue={setFieldValue}
                                                enablePreview={true}
                                                name={"document" + item.id}
                                                fileExtensions=".jpeg, .png, .jpg, .pdf, .doc, .docx"
                                                values={values}
                                                fieldName={"document" + item.id}
                                                documentHidden={
                                                  documentTypeDetails
                                                }
                                                setDocumentHidden={
                                                  setDocumentTypeDetails
                                                }
                                                fromLoanRequest={true}
                                                index={index}
                                              />
                                            </div>
                                          </div>

                                          {values[
                                            documentTypeDetails?.[index]
                                              ?.docFieldName
                                          ] &&
                                            !documentTypeDetails?.[index]
                                              ?.hide && (
                                              <div>
                                                <ContentPreviewer
                                                  data={
                                                    values[
                                                      documentTypeDetails?.[
                                                        index
                                                      ]?.docFieldName
                                                    ]?.[0]?.lastModified
                                                      ? URL.createObjectURL(
                                                          values[
                                                            documentTypeDetails?.[
                                                              index
                                                            ]?.docFieldName
                                                          ]?.[0]
                                                        )
                                                      : values[
                                                          documentTypeDetails?.[
                                                            index
                                                          ]?.docFieldName
                                                        ]?.[0]?.url
                                                  }
                                                />
                                              </div>
                                            )}
                                        </div>
                                      );
                                    })}
                                  </>
                                  <div
                                    style={{
                                      padding: "10px",
                                      borderRadius: "5px",
                                      backgroundColor: "#c6e0ff",
                                    }}
                                  >
                                    <div className="d-flex justify-content-between align-items-baseline">
                                      <div>
                                        <b> Download Template</b> <br /> you can
                                        download a template or upload a document
                                      </div>
                                      <div
                                        style={{
                                          marginLeft: "auto",
                                          display: "flex",
                                        }}
                                      >
                                        <FontAwesomeIcon
                                          className="primary-small"
                                          style={{
                                            fontWeight: "300",
                                            fontSize: "20px",
                                            marginRight: "5px",
                                            paddingRight: "2px",
                                            paddingLeft: "4px",
                                            cursor: "pointer",
                                          }}
                                          icon={faDownload}
                                        />
                                        <div className="primary-small">
                                          {" "}
                                          Download{" "}
                                        </div>

                                        <div style={{ position: "relative" }}>
                                          <FontAwesomeIcon
                                            style={{
                                              fontWeight: "300",
                                              color: "$primary",
                                              fontSize: "20px",
                                              cursor: "pointer",
                                              backgroundColor: "#c6e0ff",
                                            }}
                                            icon={faAngleDown}
                                            onClick={onExpand}
                                          />

                                          {expand ? (
                                            <ul
                                              className="download-dropdown"
                                              style={{ left: "-105px" }}
                                            >
                                              <li className="text-black">
                                                Download file
                                              </li>
                                              <li
                                                onClick={() =>
                                                  DownloadTemplate(1)
                                                }
                                              >
                                                Spousal Consent
                                              </li>
                                              <li
                                                onClick={() =>
                                                  DownloadTemplate(2)
                                                }
                                              >
                                                Promissory Note
                                              </li>
                                            </ul>
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </>
                          )}
                        </>
                      )}
                    </div>

                    {employeeEligiblePlans[selectedPlan] && (
                      <div
                        className="request-Summary"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          height: "80vh",

                          border: "1px solid #D1D1D1",
                          borderTop: "none",
                          width: "30%",
                        }}
                      >
                        <p
                          style={{
                            fontWeight: "500",
                            fontSize: "14px",
                            color: "#777777",
                            padding: "20px 0px 0px 20px",
                          }}
                        >
                          Review summary
                        </p>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            padding: "20px 20px 20px 20px",
                            borderTop: "1px solid #D1D1D1",
                          }}
                        >
                          <p
                            style={{
                              fontWeight: "400px",
                              fontSize: "12px",
                              color: "#777777",
                              margin: "0px",
                            }}
                          >
                            Plan Name
                          </p>
                          <p
                            style={{
                              fontWeight: "600",
                              fontSize: "14px",
                              color: "#3B3B3B",
                              margin: "0px",
                            }}
                          >
                            {employeeEligiblePlans[selectedPlan].planName}
                          </p>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            padding: "20px 20px 20px 20px",
                            borderTop: "1px dashed #D1D1D1",
                          }}
                        >
                          <p
                            style={{
                              fontWeight: "400px",
                              fontSize: "12px",
                              color: "#777777",
                              margin: "0px",
                            }}
                          >
                            Available balance for loan
                          </p>
                          <p
                            style={{
                              fontWeight: "600",
                              fontSize: "14px",
                              color: "#3B3B3B",
                              margin: "0px",
                            }}
                          >
                            $ {availableBalanceForLoan.toFixed(2)}
                          </p>
                        </div>
                        {values.loanType && (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              padding: "20px 20px 20px 20px",
                              borderTop: "1px dashed #D1D1D1",
                            }}
                          >
                            <p
                              style={{
                                fontWeight: "400px",
                                fontSize: "12px",
                                color: "#777777",
                                margin: "0px",
                              }}
                            >
                              Loan Type
                            </p>
                            <p
                              style={{
                                fontWeight: "600",
                                fontSize: "14px",
                                color: "#3B3B3B",
                                margin: "0px",
                              }}
                            >
                              {loanSetting
                                ? loanSetting["loanDescription"]
                                : "-"}
                            </p>
                          </div>
                        )}
                        {values.loanReason && (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              padding: "20px 20px 20px 20px",
                              borderTop: "1px dashed #D1D1D1",
                            }}
                          >
                            <p
                              style={{
                                fontWeight: "400px",
                                fontSize: "12px",
                                color: "#777777",
                                margin: "0px",
                              }}
                            >
                              Reason for loan
                            </p>
                            <p
                              style={{
                                fontWeight: "600",
                                fontSize: "14px",
                                color: "#3B3B3B",
                                margin: "0px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {values.loanReason ? values.loanReason : "-"}
                            </p>
                          </div>
                        )}
                        {values.loanRequestAmount && (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              padding: "20px 20px 20px 20px",
                              borderTop: "1px dashed #D1D1D1",
                            }}
                          >
                            <p
                              style={{
                                fontWeight: "400px",
                                fontSize: "12px",
                                color: "#777777",
                                margin: "0px",
                              }}
                            >
                              Requested amount
                            </p>
                            <p
                              style={{
                                fontWeight: "600",
                                fontSize: "14px",
                                color: "#3B3B3B",
                                margin: "0px",
                              }}
                            >
                              {values.loanRequestAmount
                                ? values.loanRequestAmount
                                : "-"}
                            </p>
                          </div>
                        )}
                      </div>
                    )}
                  </div>

                  {/* Rules slider */}

                  <SliderPanel
                    isOpen={sliderOpen1}
                    size="45"
                    onClose={() => setSliderOpen1(false)}
                    showCancel={true}
                    backdropClicked={() => setSliderOpen1(false)}
                  >
                    <div className="disp-flex-col">
                      <div
                        className="disp-flex-row"
                        style={{
                          justifyContent: "space-between",
                          fontWeight: "500",
                          fontSize: "16px",
                          borderBottom: "1px solid #BDBDBD",
                          marginBottom: "15px",
                        }}
                      >
                        <p>Policy And Procedures</p>
                      </div>
                      <ul
                        style={{
                          paddingLeft: "20px",
                          paddingRight: 0,
                          marginBottom: "20px",
                        }}
                      >
                        <li>
                          You may complete the request on paper or allow for an
                          electronic request through a website or automated
                          phone system.
                        </li>
                        <br />
                        <li>
                          You require spousal consent to be obtained at the time
                          a participant is obtaining a loan. The consent must be
                          in writing and obtained not more than 90 days prior to
                          the loan.
                        </li>
                        <br />
                        <li>
                          Your eligibility is determined based on
                          <ol>
                            <li>Is the state of employment active?</li>
                            <li>Do you have any outstanding loans?</li>
                            <li>
                              What is the amount of your vested account balance?
                            </li>
                          </ol>
                        </li>
                        <br />
                        <li>
                          You may borrow an amount that is the lesser of:
                          <ol type="a">
                            <li>
                              50% of the participant's vested account balance or
                            </li>
                            <li>
                              $50,000 (minus the difference between the highest
                              outstanding loan balance of the previous 12 months
                              and the current outstanding loan balance)
                            </li>
                          </ol>
                        </li>
                        <br />
                        <li>
                          You must be aware that to prevent the use of
                          refinancing as a means to circumvent the five-year
                          repayment requirement, if additional funds are being
                          borrowed as part of the refinancing transaction, the
                          replaced loan may need to be taken into account to
                          determine whether the five year limit is exceeded or
                          not.
                        </li>
                        <br />
                        <li>
                          You are expected to review paystubs and bank accounts
                          to confirm payments are being deducted to satisfy
                          their loan obligation.
                        </li>
                        <br />
                        <li>
                          <div>
                            Loan payments can be suspended by the Admin at
                            his/her sole discretion for the below reasons:
                            <ol>
                              <li>
                                When you go on an unpaid leave of absence (LOA);
                              </li>
                              <li>
                                When you go on a paid leave of absence, but the
                                participant's pay is less than the expected loan
                                amount; or
                              </li>
                              <li>
                                When you go on a military leave of absence
                                (MLOA), regardless of his or her pay status
                              </li>
                            </ol>
                          </div>
                        </li>
                        <br />
                        <li>
                          You may be allowed a cure period by the sponsor if a
                          payment is missed. The regulatory maximum cure period
                          is the last business day of the calendar quarter
                          following the calendar quarter in which the first
                          missed payment occurred.
                        </li>
                        <br />
                        <li>
                          Loans are supposed to be paid off by the original
                          maturity date. If the loan is not paid in full by the
                          original maturity date, it will be considered in
                          default unless a cure period applies, in which case
                          the loan can be repaid through the end of the cure
                          period to avoid the default
                        </li>
                        <br />
                        <li>
                          If a participant passes away and has an outstanding
                          loan balance, the loan will generally become
                          immediately due.
                        </li>
                        <br />
                        <li>
                          If a participant retires or terminates employment with
                          an outstanding loan, the action taken depends on the
                          plan guidelines.
                        </li>
                      </ul>
                    </div>
                  </SliderPanel>
                  <BankSlide
                    {...formProps}
                    isRepaymentBankInfo={isRepaymentBankInfo}
                    setBankSlideOpen={setBankSlideOpen}
                    bankSlideOpen={bankSlideOpen}
                    bankInformationDetails={
                      isRepaymentBankInfo
                        ? repaymentBankInformation
                        : additionalBankInformation
                    }
                    onBankSave={onBankSave}
                    fields={fields}
                    accountTypeOptions={accountTypeOptions}
                    FieldButtonGroup={FieldButtonGroup}
                    isLoanRequest={true}
                  />

                  <AddressSlide
                    {...formProps}
                    countries={countries}
                    fields={fields}
                    addressAdded={addressAdded}
                    setAddressAdded={setAddressAdded}
                    addressSlideOpen={addressSlideOpen}
                    setAddressSlideOpen={setAddressSlideOpen}
                    onAddressSave={onAddressSave}
                    setStateList={setStateList}
                    getStatesList={getStatesList}
                    stateList={stateList}
                    SearchableList={SearchableList}
                    isLoanRequest={true}
                    address={additionalAddress}
                  />

                  <SliderPanel
                    isOpen={splitupOpen}
                    size="75"
                    onClose={() => setSplitupOpen(false)}
                    showCancel={true}
                    backdropClicked={() => setSplitupOpen(false)}
                  >
                    <>
                      <div>
                        <div
                          className="disp-flex-row"
                          style={{
                            justifyContent: "space-between",
                            color: "#333333",
                            fontWeight: "500",
                            fontSize: "16px",
                          }}
                        >
                          <p>Source Wise Split-ups</p>
                        </div>
                        <div
                          style={{
                            border: "1px solid #BDBDBD",
                            width: "100%",
                            paddingLeft: "15px",
                          }}
                        >
                          <Tab.Container
                            id="left-tabs-example"
                            defaultActiveKey={0}
                          >
                            <Row>
                              <Col
                                sm={3}
                                style={{
                                  background: "#F0F0F0",
                                  //height: "100vh",
                                  margin: "0px",
                                  padding: "0px",
                                }}
                              >
                                <div
                                  style={{
                                    padding: "22px 0px 0px 36px",
                                    borderBottom: "0.5px solid #A29F9F",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <p
                                    style={{
                                      fontSize: "14px",
                                      fontWeight: "600",
                                      color: "#3B3B3B",
                                    }}
                                  >
                                    Source Name
                                  </p>
                                </div>
                                <Nav
                                  variant="pills"
                                  className="flex-column"
                                  style={{
                                    margin: "15px 0px 0px 0px",
                                    padding: "0px",
                                    width: "100%",
                                  }}
                                >
                                  {sourceSplit?.map((data, index) => (
                                    <Nav.Item
                                      style={{
                                        margin: "0px",
                                        padding: "0px",
                                        width: "100%",
                                      }}
                                    >
                                      <Nav.Link
                                        eventKey={index}
                                        style={{
                                          paddingLeft: "30px",
                                          borderRadius: "0px",
                                          fontSize: "16px",
                                          fontWeight: "500",
                                          color:
                                            index == activeIndex
                                              ? "#307BF6"
                                              : "#3B3B3B",
                                          backgroundColor:
                                            index == activeIndex
                                              ? "white"
                                              : "#F0F0F0",
                                          borderLeft:
                                            index == activeIndex &&
                                            "2px solid #307BF6",
                                        }}
                                        onClick={() => setActiveIndex(index)}
                                      >
                                        {data.sourceName}
                                      </Nav.Link>
                                    </Nav.Item>
                                  ))}
                                </Nav>
                              </Col>
                              <Col sm={9}>
                                <Tab.Content>
                                  {sourceSplit?.map((data, index) => (
                                    <Tab.Pane eventKey={index}>
                                      {/* <h2>{data.source}</h2> */}
                                      <SourceSplitupContainer
                                        data={data}
                                        values={values}
                                        module={"loans"}
                                        overnightDelivery={overnightDelivery}
                                      />
                                    </Tab.Pane>
                                  ))}
                                </Tab.Content>
                              </Col>
                            </Row>
                          </Tab.Container>
                        </div>
                      </div>
                      <div
                        className="mt-3"
                        style={{ display: "flex", flexDirection: "row" }}
                      >
                        <FontAwesomeIcon
                          style={{
                            fontWeight: "300",
                            fontSize: "17px",
                            color: "#333333",
                            marginRight: "5px",
                          }}
                          icon={faExclamationCircle}
                        />
                        <p style={{ fontWeight: "400", fontSize: "14px" }}>
                          The values shown are indicative and could vary based
                          on NAV fluctuations and account balance updates.
                        </p>
                      </div>
                    </>
                  </SliderPanel>
                  <SliderPanel
                    isOpen={sliderOpen4}
                    size="60"
                    onClose={() => setSliderOpen4(false)}
                    showCancel={true}
                    backdropClicked={() => setSliderOpen4(false)}
                  >
                    <AmortizationSchedule
                      loanStatus={"InProgress"}
                      hideDownload={true}
                      loanData={{
                        repaymentFrequency:
                          get(values, "repaymentFrequency") != null
                            ? payrollFrequency.data.find(
                                (_) =>
                                  _.label.replace("-", "") ==
                                  get(values, "repaymentFrequency")
                              )?.value
                            : null,
                        requestedAmount: get(
                          values,
                          [fields.requestedAmount],
                          null
                        ),
                        interestRate: get(values, "interestRate"),
                        tenureYears: get(values, [fields.tenureYears], null),
                        tenureMonths: get(values, [fields.tenureMonths], null),
                        periodicPayment: get(
                          values,
                          [fields.periodicPayment],
                          null
                        ),
                        firstRepaymentDate: get(
                          values,
                          [fields.firstRepaymentDate],
                          null
                        ),
                      }}
                    />
                    <div
                      className="mt-3 ml-3"
                      style={{ display: "flex", flexDirection: "row" }}
                    >
                      <FontAwesomeIcon
                        style={{
                          fontWeight: "300",
                          fontSize: "17px",
                          color: "#333333",
                          marginRight: "5px",
                        }}
                        icon={faExclamationCircle}
                      />
                      <p style={{ fontWeight: "400", fontSize: "14px" }}>
                        The values shown are indicative and could vary based on
                        different factors such as First Repayment date, NAV
                        fluctuations.
                      </p>
                    </div>
                  </SliderPanel>

                  <SliderPanel
                    isOpen={moreInfoSlideOpen}
                    size="80"
                    showCancel={false}
                    backdropClicked={() => setMoreInfoSlideOpen(false)}
                  >
                    <EmployeeSliderDetails
                      fields={fields}
                      filteredValues={filteredValues}
                      setMoreInfoSlideOpen={setMoreInfoSlideOpen}
                    />
                  </SliderPanel>
                </ManageDistributionLayout>
              </Form>
            );
          }}
        </Formik>
      </LoaderWrapper>
    </>
  );
};
export default LoanRequestContainer;
